module.exports = __webpack_public_path__ + "static/media/hiring.e6690be6.svg";